import { useGoogleMap } from "@react-google-maps/api"
import { useEffect, useRef } from "react"
import { groupsSignature } from "lib/map"
import { addClusteredPins } from "./cluster"

// These components render nothing: they only keep Google Maps objects on the map. They live
// inside <GoogleMap>, so useGoogleMap() gives them the map instance.

// Pins of all locations, grouped by zoom. Redrawn only when the pins really change.
export function Pins({ groups, onSelect }) {
  const map = useGoogleMap()
  const signature = groupsSignature(groups)
  const latest = useRef({ groups, onSelect })
  latest.current = { groups, onSelect }

  useEffect(() => {
    if (!map) return undefined
    return addClusteredPins(map, latest.current.groups, (key) => latest.current.onSelect(key))
  }, [map, signature])

  return null
}

// A blue dot where the user is
export function UserDot({ position }) {
  const map = useGoogleMap()

  useEffect(() => {
    if (!map || !position) return undefined
    const maps = window.google.maps
    const marker = new maps.Marker({
      map,
      position,
      title: "Your location",
      clickable: false,
      zIndex: 2000,
      icon: {
        path: maps.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: "#3965FF",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 3,
      },
    })
    return () => marker.setMap(null)
  }, [map, position])

  return null
}
